import axios from "axios";
import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
} from "./reducer";

const REGISTER_ENDPOINT = "/user/signup";

export const registerUser = (user: any) => async (dispatch: any) => {
  try {
    const response = await axios.post(REGISTER_ENDPOINT, {
      email: user.email,
      password: user.password,
      fullName: user.fullName,
      companyName: user.company,
    });
    const data = response && response.data ? response.data : response;
    dispatch(registerUserSuccessful(data));
  } catch (error) {
    let message = "Unable to register. Please try again.";
    if (typeof error === "string") {
      message = error;
    } else if (error && typeof error === "object") {
      const axiosError = error as any;
      message = axiosError?.response?.data?.message || axiosError?.message || message;
    }
    dispatch(registerUserFailed({ message }));
  }
};

export const resetRegisterFlag = () => {
  try {
    return resetRegisterFlagChange();
  } catch (error) {
    return error;
  }
};
